import React from 'react';

const UserPay = () => {
    return (
        <div>
            <h2>Payment is coming soon...</h2>
        </div>
    );
};

export default UserPay;